import React, { useState, useRef, useEffect } from 'react';
import { IdentidadeFeed } from '../types/identidadeFeed';

export interface IdentidadeFeedSelectorProps {
  identidades: IdentidadeFeed[];
  identidadeSelecionada: IdentidadeFeed;
  onSelecionar: (identidade: IdentidadeFeed) => void;
  compacto?: boolean;
}

const IdentidadeFeedSelector: React.FC<IdentidadeFeedSelectorProps> = ({
  identidades,
  identidadeSelecionada,
  onSelecionar,
  compacto = false,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  if (identidades.length === 0) return null;

  const label = compacto ? 'Interagindo como:' : 'Publicando como:';
  const fontSize = compacto ? 'font-xsssss' : 'font-xssss';

  // Quando há apenas 1 identidade: card estático (não interativo)
  if (identidades.length === 1) {
    return (
      <div className="d-flex align-items-center gap-2">
        <span className={`${fontSize} fw-600 text-grey-500`}>{label}</span>
        <div className="btn btn-light btn-sm d-flex align-items-center gap-2" style={{ cursor: 'default' }}>
          <img
            src={identidadeSelecionada.imagemUrl || '/assets/images/avatar.jpg'}
            alt=""
            className="rounded-circle"
            style={{ width: 24, height: 24, objectFit: 'cover' }}
          />
          <span className={`${fontSize} fw-600`}>
            {identidadeSelecionada.nome}
          </span>
        </div>
      </div>
    );
  }

  // Quando há 2+ identidades: dropdown interativo
  const menuClass = open ? 'show' : '';

  const handleSelecionar = (identidade: IdentidadeFeed) => {
    onSelecionar(identidade);
    setOpen(false);
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <span className={`${fontSize} fw-600 text-grey-500`}>{label}</span>
      <div className="dropdown" ref={dropdownRef}>
        <button
          className="btn btn-light btn-sm dropdown-toggle d-flex align-items-center gap-2"
          type="button"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <img
            src={identidadeSelecionada.imagemUrl || '/assets/images/avatar.jpg'}
            alt=""
            className="rounded-circle"
            style={{ width: 24, height: 24, objectFit: 'cover' }}
          />
          <span className={`${fontSize} fw-600`}>
            {identidadeSelecionada.nome}
          </span>
        </button>
        <ul className={`dropdown-menu ${menuClass}`}>
          {identidades.map((identidade) => (
            <li key={`${identidade.tipo}-${identidade.id}`}>
              <button
                className={`dropdown-item d-flex align-items-center gap-2 ${
                  identidade.tipo === identidadeSelecionada.tipo &&
                  identidade.id === identidadeSelecionada.id
                    ? 'active'
                    : ''
                }`}
                type="button"
                onClick={() => handleSelecionar(identidade)}
              >
                <img
                  src={identidade.imagemUrl || '/assets/images/avatar.jpg'}
                  alt=""
                  className="rounded-circle"
                  style={{ width: 24, height: 24, objectFit: 'cover' }}
                />
                <span className={`${fontSize} fw-600`}>{identidade.nome}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default IdentidadeFeedSelector;
